import { PriorityStatus, Status, UserAvatar } from '@/components';
import { RequestDetails } from '@/modules/Requests/domain';
import { DateUtility } from '@/utils';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { InfoItem } from '../InfoItem';

interface RequestBaseInfoProps {
  request: RequestDetails;
}

export const RequestBaseInfo = ({ request }: RequestBaseInfoProps) => {
  const { i18n } = useTranslation();
  return (
    <div className="flex flex-col gap-[30px]">
      <div className="flex flex-col">
        <h3>{request.title}</h3>
        <p className="text-sm font-bold text-gray-400">
          {DateUtility.formatDate(request.createdAt, i18n.language, {
            monthFormat: 'long',
            yearFormat: 'numeric',
          })}
        </p>
      </div>
      {request.description && (
        <p className="max-h-48 overflow-auto whitespace-pre text-wrap text-sm">
          <Markdown remarkPlugins={[remarkGfm]}>{request.description}</Markdown>
        </p>
      )}
      <div className="grid grid-cols-4 py-2.5">
        <InfoItem
          title={t('request_base_info_status')}
          value={<Status status={request.status} />}
        />
        <InfoItem
          title={t('request_base_info_claimant')}
          value={
            <UserAvatar
              size="small"
              name={request.createdBy?.fullName}
              withOusideName
            />
          }
        />
        <InfoItem
          title={t('request_base_info_priority')}
          value={<PriorityStatus value={request.priority} withLabel />}
        />
        <InfoItem
          title={t('request_base_info_responsable')}
          value={
            <UserAvatar
              size="small"
              name={request.userResponsible?.fullName}
              withOusideName
            />
          }
        />
      </div>
    </div>
  );
};
